import DOMPurify from 'isomorphic-dompurify';
import { parseDocument } from 'htmlparser2';
import { DomUtils } from 'htmlparser2';
import serialize from 'dom-serializer';

/*
    The main purpose of sanitizedContent function is to ensure that any HTML content passed to it is safe to render in a web application. 
    This is particularly important to prevent XSS attacks where malicious scripts could be injected into the page via user input or other 
    sources of dynamic content.
*/
const sanitizedContent = (html) => {
    // Sanitize the HTML content
    const sanitizedHtml = DOMPurify.sanitize(html);

    // Parse the sanitized HTML
    const document = parseDocument(sanitizedHtml);

    // Find all anchor tags and set target="_blank" except when href="#"
    const links = DomUtils.findAll(elem => elem.name === 'a', document.children);
    links.forEach(link => {
        link.attribs = link.attribs || {};
        const linkHref = link?.attribs?.href;

        if (linkHref && linkHref.includes(process.env.NEXT_PUBLIC_APP_URL)) {
            link.attribs.target = '_self';
        } else {
            link.attribs.target = '_blank';
        }
    });

    // Serialize the modified document back to a string
    const updatedHtml = serialize(document);

    // Return the modified HTML
    return updatedHtml;
};

export default sanitizedContent;